import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiesPolicy from './pages/CookiesPolicy';
import RecoveryLanding from './pages/RecoveryLanding';
import FleetSaveLanding from './pages/FleetSaveLanding';
import StaffPortalLogin from './pages/StaffPortalLogin';
import DriverLogin from './pages/DriverLogin';
import AdminLogin from './pages/AdminLogin';
import ClientAuth from './pages/ClientAuth';
import ClientDashboard from './pages/ClientDashboard';
import DriverDashboard from './pages/DriverDashboard';
import AdminDashboard from './pages/AdminDashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import DriverResetPassword from './pages/DriverResetPassword';
import ChangePassword from './pages/ChangePassword';
import ServiceDetailPage from './pages/ServiceDetailPage';
import AuthCallback from './pages/AuthCallback';
import ClientLanding from './pages/ClientLanding';
import { Toaster } from 'sonner';
import './App.css';

const LANDING_THEME_ROUTES = new Set(['/', '/recuperacion', '/flotas', '/client-landing']);

function ThemeScopeManager() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    const shouldUseLandingTheme = LANDING_THEME_ROUTES.has(pathname);
    document.body.classList.toggle('ag-marketing-theme', shouldUseLandingTheme);

    return () => {
      document.body.classList.remove('ag-marketing-theme');
    };
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeScopeManager />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/recuperacion" element={<RecoveryLanding />} />
          <Route path="/flotas" element={<FleetSaveLanding />} />
          <Route path="/politica-de-privacidad" element={<PrivacyPolicy />} />
          <Route path="/politica-de-cookies" element={<CookiesPolicy />} />
          <Route path="/login" element={<StaffPortalLogin />} />
          <Route path="/team-login" element={<StaffPortalLogin />} />
          <Route path="/portal/login" element={<StaffPortalLogin />} />
          <Route path="/driver/login" element={<DriverLogin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/client/login" element={<ClientAuth />} />
          <Route path="/dashboard" element={<ClientDashboard />} />
          <Route path="/driver/dashboard" element={<DriverDashboard />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/driver/reset-password" element={<DriverResetPassword />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/service/:serviceId" element={<ServiceDetailPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/client-landing" element={<ClientLanding />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;